import { render, staticRenderFns } from "./SearchChallenge.vue?vue&type=template&id=207627f8&scoped=true"
import script from "./SearchChallenge.vue?vue&type=script&lang=js"
export * from "./SearchChallenge.vue?vue&type=script&lang=js"
import style0 from "./SearchChallenge.vue?vue&type=style&index=0&id=207627f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207627f8",
  null
  
)

export default component.exports